// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/png/drawer_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-md[data-v-0fa74450] {
  background: none !important;
}
ion-content[data-v-0fa74450]::part(background) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: bottom;
  background-size: 100%;
}
#app-version[data-v-0fa74450] {
  position: absolute;
  bottom: calc(env(safe-area-inset-bottom) + 0px);
  right: calc(env(safe-area-inset-right) + 10px);
  font-family: "Roboto", sans-serif;
  font-weight: normal;
  font-size: 12px;
  color: #aaa;
}
ion-content[data-v-0fa74450]::part(background) {
  background-color: white;
}
.ion-palette-dark ion-content[data-v-0fa74450]::part(background) {
  background-color: #363636;
}
ion-list[data-v-0fa74450] {
  background-color: white !important;
}
.ion-palette-dark ion-list[data-v-0fa74450] {
  background-color: #363636 !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
